export const ZAVHOZ_STATUSES = {
  new: { label: 'Новая', color: 'primary' },
  in_work: { label: 'В работе', color: 'warning' },
  completed: { label: 'Выполнена — подтвердите', color: 'success' },
  confirmed: { label: 'Подтверждена', color: 'default' },
  rejected_by_reporter: { label: 'Возвращена в работу', color: 'danger' },
  cancelled: { label: 'Отменена', color: 'default' },
};

export const ZAVHOZ_CATEGORIES = ['Сантехника', 'Электрика', 'Мебель', 'Клининг', 'Прочее'];

export const ZAVHOZ_ACTION_LABELS = {
  created: 'Заявка создана',
  create: 'Заявка создана',
  assigned: 'Назначен исполнитель',
  assign: 'Назначен исполнитель',
  started: 'Взята в работу',
  start_work: 'Взята в работу',
  completed: 'Отмечена как выполненная',
  complete: 'Отмечена как выполненная',
  confirmed: 'Выполнение подтверждено',
  confirm: 'Выполнение подтверждено',
  returned: 'Возвращена в работу',
  return: 'Возвращена в работу',
  rejected_by_reporter: 'Возвращена в работу',
  cancelled: 'Заявка отменена',
  cancel: 'Заявка отменена',
  commented: 'Комментарий',
  comment: 'Комментарий',
};

export function zavhozActionLabel(action) {
  return ZAVHOZ_ACTION_LABELS[action] || action;
}
